export default function ZodiacOrb({ size = 600, opacity = 0.07, animate = true }) {
  const spokes = Array.from({ length: 12 }, (_, i) => {
    const angle = (i * 30 - 90) * (Math.PI / 180);
    const innerR = 115;
    const outerR = 235;
    return {
      x1: 250 + innerR * Math.cos(angle),
      y1: 250 + innerR * Math.sin(angle),
      x2: 250 + outerR * Math.cos(angle),
      y2: 250 + outerR * Math.sin(angle),
    };
  });

  const dots = Array.from({ length: 12 }, (_, i) => {
    const angle = (i * 30 - 75) * (Math.PI / 180);
    const r = 235;
    return { cx: 250 + r * Math.cos(angle), cy: 250 + r * Math.sin(angle) };
  });

  return (
    <svg
      viewBox="0 0 500 500"
      width={size}
      height={size}
      style={{
        position: "absolute",
        pointerEvents: "none",
        opacity,
        animation: animate ? "orbSpin 80s linear infinite" : "none",
      }}
    >
      {/* Outer rings */}
      <circle cx="250" cy="250" r="240" fill="none" stroke="#B89047" strokeWidth="0.8" />
      <circle cx="250" cy="250" r="235" fill="none" stroke="#B89047" strokeWidth="0.3" />
      <circle cx="250" cy="250" r="175" fill="none" stroke="#B89047" strokeWidth="0.5" />
      <circle cx="250" cy="250" r="115" fill="none" stroke="#B89047" strokeWidth="0.5" />
      <circle cx="250" cy="250" r="60" fill="none" stroke="#B89047" strokeWidth="0.4" />

      {/* Spokes */}
      {spokes.map((s, i) => (
        <line key={i} x1={s.x1} y1={s.y1} x2={s.x2} y2={s.y2} stroke="#B89047" strokeWidth="0.6" />
      ))}

      {/* Dots at zodiac positions */}
      {dots.map((d, i) => (
        <circle key={i} cx={d.cx} cy={d.cy} r="2.5" fill="#B89047" />
      ))}

      {/* Inner cross */}
      <line x1="250" y1="195" x2="250" y2="170" stroke="#B89047" strokeWidth="0.5" />
      <line x1="250" y1="305" x2="250" y2="330" stroke="#B89047" strokeWidth="0.5" />
      <line x1="195" y1="250" x2="170" y2="250" stroke="#B89047" strokeWidth="0.5" />
      <line x1="305" y1="250" x2="330" y2="250" stroke="#B89047" strokeWidth="0.5" />

      {/* Center dot */}
      <circle cx="250" cy="250" r="4" fill="#B89047" opacity="0.6" />
    </svg>
  );
}
